<script setup lang="ts">
import SimpleSpinner from "@/components/layouts/SimpleSpinner.vue";
import { onMounted, ref } from "vue";

interface Props {
  textKey?: string;
}

withDefaults(defineProps<Props>(), {
  textKey: "global.loading",
});

const dialogRef = ref<HTMLDialogElement>();

onMounted(() => {
  dialogRef.value?.showModal();
});
</script>

<template>
  <dialog
    ref="dialogRef"
    class="fixed inset-0 flex items-center justify-center bg-opacity-50 z-[100] backdrop:bg-neutral1000 backdrop:opacity-40 rounded-lg outline-none"
    @cancel.prevent
  >
    <div
      class="bg-white p-6 px-20 rounded-lg shadow-large flex flex-col items-center gap-4 overflow-hidden"
    >
      <SimpleSpinner size="8" />
      <p class="font-medium text-gray-600">{{ $t(textKey) }}</p>
    </div>
  </dialog>
</template>
